import * as ActionTypes from '../constants/ActionTypes';
import API from '../helpers/api';

export function getEnumData() {
	return async dispatch => {
		dispatch({
			type: ActionTypes.GET_ENUM_DATA_REQUEST,
			payload: { loading: true }
		});

		try {
			const [categoriesRes, paymentMethodsRes, currenciesRes] = await Promise.all([
				API.enum_data.getExpenseCategories(),
				API.enum_data.getPaymentMethods(),
				API.enum_data.getCurrencies()
			]);

			if (categoriesRes.meta.code !== 200 || paymentMethodsRes.meta.code !== 200 || currenciesRes.meta.code !== 200) {
				dispatch({
					type: ActionTypes.GET_ENUM_DATA_ERROR,
					payload: { loading: false }
				});
				return;
			}

			const { expense_categories } = categoriesRes.data;
			const { payment_methods } = paymentMethodsRes.data;
			const { currencies } = currenciesRes.data;

			dispatch({
				type: ActionTypes.GET_ENUM_DATA_SUCCESS,
				payload: {
					loading: false,
					expenseCategories: expense_categories.map(c => ({ value: c.slug, label: c.label })),
					paymentMethods: payment_methods.map(m => ({ value: m.slug, label: m.label })),
					currencies: currencies.map(c => ({
						code: c.code,
						symbol: c.symbol,
						name: c.name,
						value: c.code,
						label: `${c.name}  (${c.symbol})`
					}))
				}
			});
		} catch (e) {
			dispatch({
				type: ActionTypes.GET_ENUM_DATA_ERROR,
				payload: { loading: false }
			});
		}
	};
}
